import * as Types from '../../__generated_types__/types.generated';

import { gql } from '@apollo/client';
export type PromotionTranslationFieldsFragment = { __typename?: 'magicx_promotions_translations', title?: string | null, subtitle?: string | null, description?: string | null, eligible_customers?: string | null, how_to_claim?: string | null, terms?: string | null, cta_copy?: string | null, cta_url?: string | null, slug?: string | null, languages_language_code?: { __typename?: 'languages', language_code: string } | null };

export const PromotionTranslationFieldsFragmentDoc = gql`
    fragment PromotionTranslationFields on magicx_promotions_translations {
  languages_language_code {
    language_code
  }
  title
  subtitle
  description
  eligible_customers
  how_to_claim
  terms
  cta_copy
  cta_url
  slug
}
    `;